(function (Drupal, once) {
  'use strict';

	Drupal.behaviors.flipTOLinks = {
		initialized: false, 

		targetLinks: `[href*="be.synxis.com"]`,
		targetForm: `.booking-header-form,.booking-room-form`,

		attach: function(context, settings){
			
			// ****** On Live the _ga-ft params are already added to all the cta... leaving commented code just in case

			// once('fliptolinks', this.targetLinks, context).forEach(function(link) {
			// 	if ('function' == typeof window.fliptoDecorate) {
			// 		var bookingEngineUrl = fliptoDecorate(link.href);
			// 		link.href = bookingEngineUrl;
			// 	}
			// });

			once('fliptolinksForm', this.targetForm, context).forEach(function(form) {
				if ('function' == typeof window.fliptoDecorate) {
						fliptoDecorate(form);
					}
			})
		
		},

}
}(Drupal, once));